import { render, staticRenderFns } from "./participant-activity-response-query-comment-item.vue?vue&type=template&id=6fbc0ac5&scoped=true&"
import script from "./participant-activity-response-query-comment-item.vue?vue&type=script&lang=js&"
export * from "./participant-activity-response-query-comment-item.vue?vue&type=script&lang=js&"
import style0 from "./participant-activity-response-query-comment-item.vue?vue&type=style&index=0&id=6fbc0ac5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc0ac5",
  null
  
)

component.options.__file = "participant-activity-response-query-comment-item.vue"
export default component.exports